import { forwardRef, type Ref, type SVGProps } from "react";
const IconHDRFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M16 13.52h-.78v4.38h.63c1.4 0 2.11-.74 2.11-2.21s-.62-2.17-1.96-2.17m6.83 0h-.44v1.82h.47a1.83 1.83 0 0 0 1-.23.8.8 0 0 0 .33-.71.74.74 0 0 0-.33-.68 2.1 2.1 0 0 0-1.03-.2"
    />
    <path
      fill="currentColor"
      d="M29 6.09H3a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h26a1 1 0 0 0 1-1v-18a1 1 0 0 0-1-1m-16.93 13h-1.45v-2.92H7.9v2.91H6.44v-6.73H7.9V15h2.72v-2.65h1.45Zm6.47-.89a4 4 0 0 1-2.79.89h-1.94v-6.74H16a3.68 3.68 0 0 1 2.62.87 3.16 3.16 0 0 1 .93 2.43 3.23 3.23 0 0 1-1.01 2.54Zm6.27.89-1.64-2.59h-.78v2.58h-1.46v-6.73h2a3.5 3.5 0 0 1 2.07.5 1.76 1.76 0 0 1 .67 1.52 1.77 1.77 0 0 1-.33 1.05 2.2 2.2 0 0 1-1 .73c1 1.51 1.71 2.49 2 2.93Z"
    />
  </svg>
);
const ForwardRef = forwardRef(IconHDRFilledSVG);
ForwardRef.displayName = "IconHDRFilled";
export { ForwardRef as IconHDRFilled };
